<template>
    <div class="relative width_100_percent height_100_percent display flex align_start root_panel">
        <div class="relative height_100_percent border left">
            <Card>
                <div slot="title">组件</div>
                <div class="relative width_100_percent flex align_center flex_wrap component_container">
                    <div class="relative flex align_center justify_center component_item" v-for="info in componentList" :key="info.type" @click="onAddComponent(info)">{{ info.title }}</div>
                </div>
            </Card>
        </div>
        <div class="relative height_100_percent border center">
            <div class="mt_20 relative width_100_percent flex flex_wrap align_center justify_center screen_menu">
                <div v-for="(screenInfo, screenIdx) in screenList" :key="screenInfo.id" class="flex align_center justify_center border item" :class="{ checked: currentScreenIdx == screenIdx }" @click="onChangeScreen(screenIdx)">
                    第{{ screenIdx + 1 }}屏
                </div>
                <Button class="ml_30" type="primary" ghost shape="circle" icon="md-add" @click="onAddScreen"></Button>
            </div>
            <div class="flex align_center justify_center">
                <div class="mt_10 relative margin_h_center phone_panel">
                    <div
                        v-for="(info, groupIdx) in screenDetail"
                        :key="'group_item' + groupIdx"
                        class="relative mt_20 margin_h_center width_100_percent flex column group"
                        :class="{ checked: groupIdx == currentGroupIdx }"
                        @click.stop.prevent="onClickGroup(groupIdx)"
                    >
                        <div class="relative fontsize_35 font_weight group_name">{{ info.title }}</div>
                        <div
                            class="relative mt_20 flex align_center field_panel"
                            :class="{ checked: groupIdx === currentGroupIdx && componentIdx == currentComponentIdx }"
                            v-for="(subInfo, componentIdx) in info.list"
                            :key="subInfo.id"
                            @click.stop.prevent="onClickComponent(componentIdx, groupIdx)"
                        >
                            <template v-if="[componentType.text.value, componentType.select.value].includes(subInfo.type)">
                                <div class="fontsize_30 label">{{ subInfo.title }}</div>
                                <div :class="subInfo.type" class="flex align_center justify_center fontsize_30 font_weight">
                                    {{ componentType[subInfo.type].title || '' }}
                                </div>
                            </template>
                            <div :class="subInfo.type" v-else-if="componentType.textarea.value === subInfo.type">
                                <div class="fontsize_35 label">{{ subInfo.title }}</div>
                                <div class="margin_h_center input"></div>
                            </div>
                            <div class="margin_h_center flex column align_center justify_center" :class="subInfo.type" v-else-if="componentType.upload.value === subInfo.type">
                                <Icon class="fontsize_60" type="md-images" />
                                <div class="fontsize_26 font_weight">{{ subInfo.title }}</div>
                            </div>
                            <div class="margin_h_center flex column align_center justify_center" :class="subInfo.type" v-else-if="componentType.uploadMultiple.value === subInfo.type">
                                <Icon class="fontsize_60" type="md-images" />
                                <div class="fontsize_26 font_weight">{{ subInfo.title }}</div>
                            </div>
                            <div class="margin_h_center flex column align_center justify_center"  v-else-if="componentType.spectralDiagram.value === subInfo.type">
                                <!-- <Icon class="fontsize_60" type="md-images" /> -->
                                <div class="fontsize_30" style="margin-left: -469px;">{{ subInfo.title }}</div>
                                <img style="width: 311px;height: 237px;" src="../../assets/gpt.png" /> 
                            </div>

                            <div v-if="info.list.length > 1" class="absolute align_center justify_center bottom0 right0 manager_panel">
                                <Icon class="fontsize_32 btn" type="ios-trash" @click="onDelete(componentIdx)" />
                                <Icon class="ml_10 fontsize_32 btn" type="md-arrow-up" @click="onMove(componentIdx, -1)" />
                                <Icon class="ml_10 fontsize_32 btn" type="md-arrow-down" @click="onMove(componentIdx, 1)" />
                            </div>
                        </div>

                        <div v-if="screenDetail.length > 1" class="absolute align_center justify_center top0 right0 manager_panel">
                            <Icon class="fontsize_32 btn" type="ios-trash" @click="onDeleteGroup(groupIdx)" />
                            <Icon class="ml_10 fontsize_32 btn" type="md-arrow-up" @click.stop="onMoveGroup(groupIdx, -1)" />
                            <Icon class="ml_10 fontsize_32 btn" type="md-arrow-down" @click.stop="onMoveGroup(groupIdx, 1)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="relative height_100_percent border right">           
            <Card title="模版基础配置">
                <div class="form_item">
                    <div class="form_label">模版名称</div>
                    <Input v-model.trim="formData.title" :maxlength="20" show-word-limit></Input>
                </div>
                <div class="form_item">
                    <div class="form_label">模版状态</div>
                    <RadioGroup v-model="formData.status" type="button" button-style="solid">
                        <Radio label="1">开启</Radio>
                        <Radio label="0">关闭</Radio>
                    </RadioGroup>
                </div>
                <div class="form_item">
                    <div class="form_label">选择分类</div>
                    <Select filterable v-model="formData.cid">
                        <Option v-for="info in classList" :value="info.id" :key="info.id">{{ info.title }}</Option>
                    </Select>
                </div>
            </Card>
            <Card title="组名配置" v-if="screenDetail.length > 0">
                <div class="form_item">
                    <div class="form_label align_self_start">组名</div>
                    <Input type="textarea" :rows="2" v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].title" :maxlength="20" show-word-limit></Input>
                </div>
            </Card>
            <card v-if="isNotNullObject(currentComponent)" :title="componentType[currentComponent.type].title + '配置'">
                <div class="form_item">
                    <div class="form_label">字段名</div>
                    <Input v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].title" :maxlength="7" show-word-limit></Input>
                </div>
                <template v-if="[componentType.text.value, componentType.textarea.value].includes(currentComponent.type)">
                    <div class="form_item">
                        <div class="form_label">是否必填</div>
                        <RadioGroup v-model="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].mustinput" type="button" button-style="solid">
                            <Radio label="1">是</Radio>
                            <Radio label="0">否</Radio>
                        </RadioGroup>
                    </div>
                    <div class="form_item">
                        <div class="form_label">字数限制</div>
                        <Input v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].maxLength" :maxlength="3" show-word-limit></Input>
                    </div>
                    <div class="form_item">
                        <div class="form_label align_self_start">提示文本</div>
                        <Input type="textarea" :rows="3" v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].placeholder" :maxlength="30" show-word-limit></Input>
                    </div>
                </template>
                <template v-if="componentType.text.value == currentComponent.type">
                    <div class="form_item">
                        <div class="form_label">最小阀值</div>
                        <Input v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].thresholdMin"></Input>
                    </div>
                    <div class="form_item">
                        <div class="form_label">最大阀值</div>
                        <Input v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].thresholdMax"></Input>
                    </div>
                    <div class="form_item">
                        <div class="form_label">阀值提示语</div>
                        <Input v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].thresholdTxt"></Input>
                    </div>
                    <div class="form_item">
                        <div class="form_label">单位</div>
                        <Input v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].unit"></Input>
                    </div>
                </template>
                <div v-if="componentType.uploadMultiple.value == currentComponent.type" class="form_item">
                    <div class="form_label">最多可上传</div>
                    <Input class="width_100" v-model.trim="screenList[currentScreenIdx].list[currentGroupIdx].list[currentComponentIdx].maxImageLength"></Input>
                    <div class="ml_10">张</div>
                </div>
            </card>
            <card class="relative mt_20 width_100_percent flex align_center justify_center btn_panel">
                <Button @click="onCancel">返回</Button>
                <Button type="primary" :loading="ajaxLoading" class="ml_30" @click="onSubmit">保存</Button>
            </card>
        </div>
        <mySpin :loading="ajaxLoading"></mySpin>
    </div>
</template>
<script>
import { reqCheckClassList, reqCheckTempView, reqSaveCheckTemp } from '@/lib/request/auth';
import { isNotEmptyString, isNotNullObject } from '@/lib/util';

export default {
    name: 'monitorManagerTemplateEdit',
    data() {
        let componentType = {
            group: { value: 'group', title: '组名' },
            text: { value: 'text', title: '单行文本' },
            textarea: { value: 'textarea', title: '多行文本' },
            select: { value: 'select', title: '下拉框' },
            upload: { value: 'upload', title: '上传图片' },
            uploadMultiple: { value: 'uploadMultiple', title: '上传多图' },
            spectralDiagram: { value: 'spectralDiagram', title: '标准光谱图' },

        };
        this.componentType = componentType;
        return {
            groupBaseData: {
                id: hm.createId(),
                list: [
                    {
                        id: hm.createId(),
                        title: ' 默认分组',
                        list: [],
                    },
                ],
            },
            componentList: [
                { title: componentType.group.title, type: componentType.group.value },
                { title: componentType.text.title, type: componentType.text.value },
                { title: componentType.textarea.title, type: componentType.textarea.value },
                { title: componentType.select.title, type: componentType.select.value },
                { title: componentType.upload.title, type: componentType.upload.value },
                { title: componentType.uploadMultiple.title, type: componentType.uploadMultiple.value },
                { title: componentType.spectralDiagram.title, type: componentType.spectralDiagram.value },

            ],
            currentScreenIdx: 0,
            currentGroupIdx: 0,
            currentComponentIdx: -1,
            screenList: [],
            isEdit: false,
            isCopy: false,
            formData: {
                id: null,
                title: null,
                from_note: null,
                status: null,
                cid: null,
            },
            classList: [],
        };
    },
    computed: {
        //当前屏的数据
        screenDetail() {
            let detail = (this.screenList[this.currentScreenIdx] || {}).list || [];
            return detail;
        },
        //当前分组的数据
        currentGroup() {
            return (this.screenDetail[this.currentGroupIdx] || {}).list || [];
        },
        //当前选中的组件
        currentComponent() {
            let detail = this.currentGroup[this.currentComponentIdx] || {};
            return detail;
        },
    },
    watch: {
        //
    },
    mounted() {
        this.routeIdInject();
        this.isCopy = +((this.currentRoute || {}).query.isCopy || 0);
        this.reqClassList();
        this.getDetail();
    },
    methods: {
        isNotNullObject,
        //获取检测分类
        reqClassList() {
            reqCheckClassList({
                pageNums: 1,
                pageSize: 200,
                status: 1,
            }).then(res => {
                this.classList = (res.data || {}).list || [];
            });
        },
        //获取详情
        getDetail() {
            if (this.isEdit) {
                this.showAjaxLoading();
                reqCheckTempView({ id: this.formData.id })
                    .then(res => {
                        this.dataInjectFormData(res);
                        let from_note = this.formData.from_note || null;
                        if (hm.isNotEmptyString(from_note)) {
                            this.screenList = JSON.parse(from_note);
                        } else {
                            this.screenList = [window.structuredClone(this.groupBaseData)];
                        }
                        this.formGroupName = this.screenList[0].list[0].title;
                        if (this.isCopy == 1) {
                            this.formData.title = '复制-' + this.formData.title;
                            this.formData.id = null;
                        }
                    })
                    .finally(() => {
                        this.hideAjaxLoading();
                    });
            }
        },
        //添加新页
        onAddScreen() {
            let data = window.structuredClone(this.groupBaseData);
            data.id = hm.createId();
            data.list[0].id = hm.createId();
            this.screenList.push(data);
        },
        //切换页
        onChangeScreen(screenIdx) {
            this.currentComponentIdx = 0;
            this.currentGroupIdx = 0;
            this.currentScreenIdx = screenIdx;
        },
        //点击左侧添加组件
        onAddComponent(componentInfo) {
            let currentScreen = this.screenList[this.currentScreenIdx] || {};
            // console.log('currentScreen', currentScreen);

            let type = componentInfo.type;
            if (type === this.componentType.group.value) {
                //添加分组
                currentScreen.list.push({
                    id: hm.createId(),
                    title: ' 默认分组',
                    list: [],
                });
                this.currentGroupIdx = currentScreen.list.length - 1;
            } else {
                //添加普通组件
                let _key = hm.createId();
                let data = {
                    id: _key,
                    title: componentInfo.title,
                    type: componentInfo.type,
                    key: _key,
                    value: null,
                    unit: null,
                    placeholder: null,
                    mustinput: '1',
                    maxLength: '10',
                    maxImageLength: 3,
                    thresholdMin: null,
                    thresholdMax: null,
                    thresholdTxt: null,
                };
                let list = currentScreen.list || [];
                if (list.length <= 0) {
                    //无分组时，先创建一个分组
                    list.push({
                        id: hm.createId(),
                        title: ' 默认分组',
                        list: [data],
                    });
                } else {
                    let currentGroup = list[this.currentGroupIdx] || [];
                    currentGroup.list.push(data);
                    this.currentComponentIdx = currentGroup.list.length - 1;
                }
            }
        },
        //选中组
        onClickGroup(groupIdx) {
            this.currentGroupIdx = groupIdx;
        },
        //选中组里面的组件
        onClickComponent(componentIdx, groupIdx) {
            this.currentGroupIdx = groupIdx;
            this.currentComponentIdx = componentIdx;
        },
        //删除分组
        onDeleteGroup(groupIdx) {
            this.screenDetail.splice(groupIdx, 1);
            this.currentGroupIdx = this.screenDetail.length - 1;
        },
        //删除组件
        onDelete(componentIdx) {
            this.currentGroup.splice(componentIdx, 1);
        },
        //移动组件
        onMove(componentIdx, direction) {
            let targetIdx = componentIdx + direction;
            let currentGroup = this.currentGroup;
            if (targetIdx < 0) {
                currentGroup.push(currentGroup.splice(componentIdx, 1)[0]);
            } else if (targetIdx > currentGroup.length - 1) {
                currentGroup.unshift(currentGroup.splice(componentIdx, 1)[0]);
            } else {
                [currentGroup[componentIdx], currentGroup[targetIdx]] = [currentGroup[targetIdx], currentGroup[componentIdx]];
            }
            this.screenList.push(0);
            this.screenList.pop();
        },
        //移动分组
        onMoveGroup(groupIdx, direction) {
            let targetIdx = groupIdx + direction;
            let screenDetail = this.screenDetail;
            if (targetIdx < 0) {
                targetIdx = screenDetail.length - 1;
                screenDetail.push(screenDetail.splice(groupIdx, 1)[0]);
            } else if (targetIdx > screenDetail.length - 1) {
                targetIdx = 0;
                screenDetail.unshift(screenDetail.splice(groupIdx, 1)[0]);
            } else {
                [screenDetail[groupIdx], screenDetail[targetIdx]] = [screenDetail[targetIdx], screenDetail[groupIdx]];
            }
            this.currentGroupIdx = targetIdx;
            this.screenList.push(0);
            this.screenList.pop();
        },
        //取消/返回
        onCancel() {
            this.$router.back();
        },
        //保存/提交
        onSubmit() {
            this.showAjaxLoading();
            console.log('###################### onAddComponent ->');
            console.log(JSON.stringify(this.screenList, null, '\t'));
            let { cid, id, title, status } = this.formData || {};
            let vs = [{ value: title, tip: '请输入模版名称' }];
            hm.validateForm(vs)
                .then(() => {
                    let screenList = this.screenList || [];
                    let errTxt = null;
                    bl: for (let screenIdx = 0; screenIdx < screenList.length; screenIdx++) {
                        let grouplist = screenList[screenIdx].list || [];
                        for (let groupIdx = 0; groupIdx < grouplist.length; groupIdx++) {
                            let groupInfo = grouplist[groupIdx] || {};
                            if (!hm.isNotEmptyString(groupInfo.title)) {
                                errTxt = `第${screenIdx + 1}屏，第${groupIdx + 1}个分组，组名不能为空`;
                                break bl;
                            } else if (groupInfo.list.length <= 0) {
                                errTxt = `第${screenIdx + 1}屏，第${groupIdx + 1}个分组【${groupInfo.title}】，组件不能为空`;
                                break bl;
                            } else {
                                let componentList = groupInfo.list || [];
                                for (let compIdx = 0; compIdx < componentList.length; compIdx++) {
                                    let compInfo = componentList[compIdx];
                                    if (!isNotEmptyString(compInfo.title)) {
                                        errTxt = `第${screenIdx + 1}屏，第${groupIdx + 1}个分组，第${compIdx + 1}个组件字段名不能为空`;
                                        break bl;
                                    }
                                }
                            }
                        }
                    }
                    if (hm.isNotEmptyString(errTxt)) {
                        this.fadeWarning(errTxt);
                        this.hideAjaxLoading();
                        return;
                    }
                    reqSaveCheckTemp({
                        cid,
                        id,
                        title,
                        status,
                        from_note: JSON.stringify(screenList),
                    })
                        .then(res => {
                            this.fadeAlert(res.errmsg);
                            console.log('this.isCopy=', this.isCopy, !!this.isCopy);
                            if (!!this.isCopy) {
                                this.onCancel();
                            }
                            window.setTimeout(() => {
                                this.hideAjaxLoading();
                            }, 500);
                        })
                        .catch(() => {
                            this.hideAjaxLoading();
                        });
                })
                .catch(msg => {
                    this.fadeWarning(msg);
                    this.hideAjaxLoading();
                });
        },
    },
};
</script>
<style lang="less" scoped>
.root_panel {
    .border {
        border: 1px #c0c0c0 solid;
    }
    .btn_panel {
        bottom: 20px;
    }
    .left,
    .right {
        flex-shrink: 0;
    }
    .right {
        width: 340px;
        .form_label {
            width: 100px;
        }
    }
    .left {
        width: 300px;
        .component_container {
            gap: 10px;
            .component_item {
                width: 120px;
                height: 40px;
                border-radius: 5px;
                color: #1a1a1a;
                cursor: pointer;
                background-image: linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%);
                transition: transform 0.3s;
                -webkit-transition: transform 0.3s;
                &:hover {
                    box-shadow: 0 0 10px #e2d1c3;
                    transform: scale(1.04);
                    -webkit-transform: scale(1.04);
                }
            }
        }
    }
    .center {
        flex: 1;
        min-width: 400px;
        // overflow: auto;
        .screen_menu {
            gap: 10px;
            .item {
                width: 80px;
                height: 30px;
                border-radius: 4px;
                cursor: pointer;
                &.checked {
                    border-color: blue;
                    color: blue;
                }
            }
        }
        .phone_panel {
            width: 750px;
            min-width: 750px;
            height: 1334px;
            transform: scale(0.5) translate(0, -50%);
            border-radius: 20px;
            padding: 20px 0;
            border: 2px #000 solid;
            background-color: #f6f6f6;
            overflow: auto;

            .manager_panel {
                width: 140px;
                height: 50px;
                background-color: rgba(135, 206, 250);
                .btn {
                    cursor: pointer;
                }
            }
            .group {
                width: 696px;
                min-height: 200px;
                background: #ffffff;
                border-radius: 25px;
                padding: 25px 0 35px;
                &.checked {
                    border: 1px red solid;
                }
                .manager_panel {
                    border-radius: 0 20px 0 26px;
                }

                .group_name {
                    border-left: 11px #ff8800 solid;
                    padding-left: 35px;
                }

                .field_panel {
                    &.checked {
                        border: 3px blue solid;
                        border-radius: 20px;
                        .manager_panel {
                            display: flex;
                        }
                    }
                    .manager_panel {
                        border-radius: 26px 0 20px 0;
                        display: none;
                    }
                    .label {
                        width: 200px;
                        padding-left: 35px;
                    }
                    .text,
                    .select {
                        width: 463px;
                        height: 67px;
                        border-radius: 5px;
                        border: 1px solid #e1e1e1;
                    }
                    .textarea {
                        width: 100%;
                        .input {
                            width: 622px;
                            height: 230px;
                            border-radius: 5px;
                            border: 1px solid #e1e1e1;
                        }
                    }
                    .upload,
                    .uploadMultiple {
                        width: 622px;
                        height: 274px;
                        background: #f6f6f6;
                        border-radius: 5px;
                    }
                }
            }
        }
    }
}
</style>
